// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__e0Z41"};